type RoleRef = { id: string; name: string };

/** Confirm text for deleting a policy; deletion silently detaches it from roles. */
export const policyDeletionMessage = (
  kind: 'data' | 'endpoint',
  name: string,
  assignedRoles: readonly RoleRef[],
): string => {
  const base = `Do you really want to delete ${kind} policy "${name}"?`;
  if (assignedRoles.length === 0) {
    return base;
  }
  const roleNames = assignedRoles.map((role) => role.name).join(', ');
  const noun = assignedRoles.length === 1 ? 'role' : 'roles';
  return `${base} It is assigned to ${assignedRoles.length} ${noun}: ${roleNames}; they will lose this policy.`;
};
